import React from "react";
import FooterContainer from "./FooterContainer";
import HeaderContainer from "./HeaderContainer";
import withFooter from "./withFooter";

export default withFooter({
  Footer: FooterContainer,
  Header: HeaderContainer,
});
